import FormViewForm from '@src/components/_forms/FormViewForm';
import {IClientModel} from '@src/@interfaces/models/Client/IClientModel';
import MaterialVariableValueField from './fields/MaterialVariableValueField';

const customFields = {
    variable_value: {
        component: MaterialVariableValueField as any
    },
};

export default class MaterialForm<Model extends IClientModel> extends FormViewForm<Model> {
    protected get customFields() {
        return customFields;
    }

    protected mutateModelFieldInitialValue(fieldName: string, modelValue: any): any {
        if (fieldName === 'variable_value') {
            return modelValue / 100;
        }

        return super.mutateModelFieldInitialValue(fieldName, modelValue);
    }
}
